import { render, staticRenderFns } from "./stockInOrderDetail.vue?vue&type=template&id=3d35a7b1&scoped=true&"
import script from "./stockInOrderDetail.vue?vue&type=script&lang=js&"
export * from "./stockInOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d35a7b1",
  null
  
)

export default component.exports